import * as actionTypes from "../actionTypes";

export default (state, action) => {
  switch (action.type) {
    case actionTypes.PROCESS_START:
      console.log("loaded");
      return {
        ...state,
        loading: true,
        bookingCounts: [],
        todayBookings: [],
        tomorrowBookings: [],
        error: null,
      };

    case actionTypes.FETCH_RECORDS:
      return {
        ...state,
        loading: false,
        error: null,
        bookingCounts: action.payload.data,
      };

    case "FETCH_TODAY_BOOKINGS":
      return {
        ...state,
        loading: false,
        error: null,
        todayBookings: action.payload.data,
      };

    case "FETCH_TOMORROW_BOOKINGS":
      return {
        ...state,
        loading: false,
        error: null,
        tomorrowBookings: action.payload.data,
      };

    case actionTypes.FETCH_ERRORS:
      return {
        ...state,
        load: false,
        loading: false,
        error: action.payload,
      };

    case "INTERPRETER_DASHBOARD_START":
      return {
        ...state,
        interpreterDashboardLoading: true,
        error: null,
      };

    case "FETCH_INTERPRETER_DASHBOARD":
      return {
        ...state,
        interpreterDashboardLoading: false,
        interpreterDashboard: action.payload.data,
        error: null,
      };

    case "INTERPRETER_DASHBOARD_ERROR":
      return {
        ...state,
        interpreterDashboardLoading: false,
        error: action.payload,
      };
    case "FINANCIAL_DASHBOARD_START":
      return {
        ...state,
        financialDashboardLoading: true,
        error: null,
      };

    case "FETCH_FINANCIAL_DASHBOARD":
      return {
        ...state,
        financialDashboardLoading: false,
        financialDashboard: action.payload.data,
        error: null,
      };

    case "FINANCIAL_DASHBOARD_ERROR":
      return {
        ...state,
        financialDashboardLoading: false,
        error: action.payload,
      };

    case "ACTIVITY_DASHBOARD_START":
      return {
        ...state,
        activityDashboardLoading: true,
        error: null,
      };

    case "FETCH_ACTIVITY_DASHBOARD":
      return {
        ...state,
        activityDashboard: action.payload,
        activityDashboardLoading: false,
        error: null,
      };

    case "ACTIVITY_DASHBOARD_ERROR":
      return {
        ...state,
        activityDashboardLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
